export default __webpack_public_path__ + "static/media/gallery - story - bard (1)_01.52d480f0.jpg";